// extracted by mini-css-extract-plugin
export default {"wrapper":"articles_wrapper__DXBbr","portfolio":"articles_portfolio__QKW3J","cardsContainer":"articles_cardsContainer__TuknN","gridColumn":"articles_gridColumn__lCHC2"};